import PropTypes from "prop-types";
import styles from "./ColourSwatch.css";
import classnames from "classnames";

const ColourSwatch = ({ backgroundColour, classNames }) => {
  const blackBorder =
    backgroundColour && backgroundColour === "#FFFFFF"
      ? styles.blackBorder
      : null;

  return (
    <div
      className={classnames(styles.swatch, classNames, blackBorder)}
      style={{ backgroundColor: backgroundColour }}
    ></div>
  );
};

ColourSwatch.propTypes = {
  backgroundColour: PropTypes.string,
  classNames: PropTypes.string
};

export default ColourSwatch;
